/**
 * @module app.ext.iccc
 */

import { AssessmentAttachmentWithLocalState } from "app/core/models/local-state-extensions";
import * as Core from 'app/core/models/essette-api';


export class AssessmentContext {

    public attachment: AssessmentAttachmentWithLocalState = {};
    public currentSession: Core.AssessmentSession = {};
    public coreSections: Core.AssessmentSection[] = [];

    public clear(): void {
        this.currentSession = {};
        this.attachment = {};
    }

}
